export const isAuthenticated = () => {
  const dataString = localStorage.getItem("userData");
  return !!dataString;
};

export const token = () => {
  const dataString = localStorage.getItem("userData");
  if (dataString) {
    try {
      const data = JSON.parse(dataString);
      return data?.token;
    } catch (e) {
      return null;
    }
  }
  return null;
};
